import React from 'react';
import './AddSubstantialChangeTypeModal.scss';
import { Modal } from '@material-ui/core';
import { useModalStyles } from '../SubstantialChangesConstants';
import { SubstantialChangeTypeForm } from './SubstantialChangeTypeForm';

type Props = {
  isOpen: boolean;
  operationType?: number;
  onSubmit: (formData: any) => void;
  closeModal: (value: boolean) => void;
  submitting: boolean;
  disableDraftSubmit: boolean;
  cancel?: (value: boolean) => void;
  data?: any;
}

export const AddSubstantialChangeTypeModal: React.FC<Props> = ({
  isOpen,
  operationType,
  onSubmit,
  cancel,
  closeModal,
  disableDraftSubmit,
  submitting,
  data
}) => {
  const classes = useModalStyles();

  return (
    <Modal
      disableBackdropClick
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      onClose={() => closeModal && closeModal(false)}
      open={isOpen}
      aria-labelledby="server-modal-title"
      aria-describedby="server-modal-description"
      className={classes.modal}
    >
      <SubstantialChangeTypeForm
        data={data}
        operationType={operationType}
        closeModal={closeModal}
        cancel={cancel}
        onSubmit={onSubmit}
        disableDraftSubmit={disableDraftSubmit}
        submitting={submitting}
      />
    </Modal>
  )
}
